import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Header from '../components/HomePage/Header/Header';
import Home from '../pages/Home';
import Explore from '../pages/Explore';
import WaterCycle from '../pages/WaterCycle';
import SolarSystem from "../pages/SolarSystem";
import Volcano from '../pages/Volcano';
import OlympusMons from '../pages/OlympusMons';	
import Chat from '../pages/ChatroomPage';
import Profile from '../pages/Profile';

function Main() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/waterCycle" element={<WaterCycle />} />
        <Route path="/solarSystem" element={<SolarSystem />} />
        <Route path="/volcano" element={<Volcano />} />
        <Route path="/olympusMons" element={<OlympusMons />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/profile" element={<Profile />} />
      </Routes>
    </BrowserRouter>
  );
}

export default Main;
